import React, {useEffect, Component } from 'react';
import googleOneTap from 'google-one-tap';
import Service from '../Service/http';
import Util from '../Service/util';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import Typewriter from "typewriter-effect";
import "./styles.css"
function Login() {
  const navigate = useNavigate();
  const service = new Service();
  const util = new Util();

  useEffect(()=>{

    if(util.loggedIn()){
      navigate("/profile");
    }


  },[])

  const particlesInit = async (main) => {
    console.log(main);
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const options = {
    client_id: '840790931700-il46j88bbumg5akh2s4vklo4o4it9jtu.apps.googleusercontent.com', // required
    auto_select: false, // optional
    cancel_on_tap_outside: false, // optional
    context: 'signin', // optional
  };

  googleOneTap(options, (response) => {

    console.log(response);

    axios.post("api/auth/login",response)
    .then(json=>{
      console.log(json);
      localStorage.setItem('token',json.data);
      window.location.href = "/profile";
    }).catch(error =>{
      console.log(error);
    })
    console.log(response);
  });


  return (
  <div className='container p-5'  style={{minHeight:"100vh",
  // backgroundImage: `url(${LoginSvg})`,
  // backgroundRepeat:'no-repeat round'
   }}>

<div id="g_id_onload"
     data-client_id="840790931700-il46j88bbumg5akh2s4vklo4o4it9jtu.apps.googleusercontent.com"
     data-context="signin"
     data-ux_mode="popup"
     data-callback="recaptcha_callback"
     data-nonce="">
</div>

<div
 className="g_id_signin"
     data-type="standard"
     data-shape="rectangular"
     data-theme="filled_blue"
     data-text="signin_with"
     data-size="large"
     data-logo_alignment="left">
</div>




<Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: "",
          },
        },
        fpsLimit: 200,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 40,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#0288D1",
          },
          links: {
            color: "#0288D1",
            distance: 150,
            enable: true,
            opacity: 1,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outModes: {
              default: "bounce",
            },
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 500,
            },
            value: 80,
          },
          opacity: {
            value: 1,
          },
          shape: {
            type: "square",
          },
          size: {
            value: { min: 1, max: 5 },
          },
        },
        detectRetina: true,
      }}
    />



<div className="gridant-color text-primary " style={{ height: "53vh", padding: 0, fontSize: "30px", textAlign: 'center', fontWeight: "bolder"}} >

            <Typewriter
                options={{
                    loop:true,
                }}
                onInit={(typewriter) => {
                    typewriter.typeString('Being Zero, Powerful Yet Humble !!')
                        .pauseFor(2500)
                        .deleteAll()
                        // typewriter.typeString('Happy Learning !!')
                        // .pauseFor(2500)
                        // .deleteAll()
                        typewriter.typeString('Happy Coding !!')
                        .pauseFor(2500)
                        .deleteAll()
                        .start();
                }}
            />



        </div>

  </div>
  );
}

export default Login;

